
import { Component, OnInit, DOCUMENT, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, tap } from 'rxjs';
import { SignalRService } from '@core/platform/signalr.service';
import { CopyPasteService } from '@core/domain/documentation/copypaste.service';
import { LoadingIndicatorService } from '@core/platform/loading-indicator.service';
import { StorageService } from '@core/platform/storage.service';
import { ElectronService } from '@core/platform/electron.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);
  private document = inject<Document>(DOCUMENT);
  private readonly translate = inject(TranslateService);
  private readonly signalRService = inject(SignalRService);
  private readonly loadingIndicator = inject(LoadingIndicatorService);

  // Nieczytane celowo: oba serwisy pracują od startu aplikacji (ElectronService słucha
  // zdarzeń PIDrive i odpala timer stanu, CopyPasteService subskrybuje schowek), więc
  // tworzymy je tutaj, zanim wejdzie pierwszy widok, który ich potrzebuje.
  private readonly copyPasteService = inject(CopyPasteService);
  private readonly electronService = inject(ElectronService);

  title = 'pialhambrafront';
  bodyClass = '';

  get isLoading() {
    return this.loadingIndicator.isLoading();
  }

  ngOnInit() {
    console.debug('AppComponent ngOnInit - starting initialization');
    this.signalRService.startConnection();

    if (StorageService.local.getItem('lng')) {
      this.translate.setDefaultLang(StorageService.local.getItem('lng') as string);
    }

    const savedLang = StorageService.local.getItem('lng') || 'pl';
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
    
    console.debug('AppComponent ngOnInit - language set to:', savedLang);

    this.translate.onDefaultLangChange.subscribe((lng) => {
      StorageService.local.setItem('lng', lng.lang);
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        tap((event) => {
          console.debug('Navigation event:', event);
        }),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route?.snapshot.data['title']) {
            return route.snapshot.data['title'];
          }
          return this.title;
        }),
        tap((title: string) => {
          console.debug('Setting title to:', title);
          this.titleService.setTitle(title);
        }),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (this.bodyClass) {
            this.document.body.classList.remove(this.bodyClass);
          }
          if (route?.snapshot.data['bodyClass']) {
            return route.snapshot.data['bodyClass'];
          }
        }),
        filter((cls) => !!cls),
        tap((cls) => {
          this.bodyClass = cls;
          this.document.body.classList.add(cls);
        })
      )
      .subscribe();
  }
}
